
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/security",
      function () {
        return require("private-next-pages/terms/security/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/security"])
      });
    }
  